import React from 'react';

import { connect } from 'react-redux';

import CompanyMetadata from '@/components/global/CompanyMetadata';
import { Loader } from '@/components/global/Loader';
import { AccessConsumePropsType } from '@/models/authModels';
import { ServerStatus } from '@/models/globalModels';
import { checkUserRole, getProfileData } from '@/redux/auth/actions';
import { RootState } from '@/redux/rootReducer';

const mapStateToProps = (state: RootState) => {
  const auth = state.auth;
  return {
    auth,
  };
};

const mapDispatchToProps = {
  checkUserRole,
  getProfileData,
};

const AccessConsume = ({ auth, getProfileData, children, roles, checkUserRole }: AccessConsumePropsType) => {
  const [hasAccess, setHasAccess] = React.useState(false);
  const [isProfileLoaded, setIsProfileLoaded] = React.useState<boolean>(false);

  // gets company and ambassador info
  React.useEffect(() => {
    if (auth.ambassadorStatus != ServerStatus.FETCH) getProfileData();
  }, []);

  // sets access based on profile and account status
  React.useEffect(() => {
    if (auth.ambassadorStatus == ServerStatus.FETCH && auth.isAccountActive) {
      setHasAccess(checkUserRole(roles));
    } else if (auth.ambassadorStatus == ServerStatus.FETCH_ERROR) {
      setHasAccess(false);
    }
  }, [auth.ambassadorStatus, checkUserRole, roles, auth.isAccountActive, auth.user]);

  // logs out if no access or profile error
  React.useEffect(() => {
    if (!hasAccess && auth.ambassadorStatus == ServerStatus.FETCH_ERROR) {
      window.location.href = '/register';
    }
  }, [hasAccess, auth.ambassadorStatus]);

  // shows loader or dashboard content
  React.useEffect(() => {
    if (auth.ambassadorStatus == ServerStatus.FETCH && auth.companyStatus == ServerStatus.FETCH) {
      setIsProfileLoaded(true);
    }
  }, [auth.ambassadorStatus, auth.companyStatus]);

  return (
    <>
      <CompanyMetadata />

      {hasAccess && isProfileLoaded ? (
        children
      ) : (
        <div className="col w-100 h-100 d-flex align-items-center">
          <Loader invert={false} size={50} strokeSize={4} />
        </div>
      )}
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(AccessConsume);
